/** City lists ported from activation-dashboard rewards-program-prototype (feature/rewards-program-prototype). */

export const CITY_OTHER = "Autre" as const;

export const ONSITE_CITIES = [
  "Casablanca",
  "Mohammedia",
  "Bouznika",
  "Bouskoura",
  "Mediouna",
  "Aïn Harrouda",
  "Berrechid",
  "Benslimane",
  "Settat",
  "El Jadida",
  "Azemmour",
  "Sidi Bennour",
  "Rabat",
  "Salé",
  "Témara",
  "Skhirat",
  "Kénitra",
  "Sidi Kacem",
  "Sidi Slimane",
  "Khémisset",
  "Tiflet",
  "Khouribga",
  "Oued Zem",
  "Boujniba",
  "Benguérir",
  "Marrakech",
  "Youssoufia",
  "Béni Mellal",
  "El Kelaâ des Sraghna",
  "Fquih Ben Salah",
  "Fkih Ben Salah",
  "Safi",
  "Souk El Arbaa",
  "Mechra Bel Ksiri",
  "Moulay Bousselham",
] as const;

export const ALL_CITIES = [
  "Afourer",
  "Agadir",
  "Agdz",
  "Aguelmous",
  "Ahfir",
  "Aïn Harrouda",
  "Aïn Taoujdate",
  "Ajdir",
  "Aklim",
  "Al Aroui",
  "Al Hoceïma",
  "Aoufous",
  "Aourir",
  "Arfoud",
  "Asilah",
  "Assa",
  "Azemmour",
  "Azilal",
  "Azrou",
  "Bab Berred",
  "Bab Taza",
  "Béni Mellal",
  "Béni Ansar",
  "Benguérir",
  "Benslimane",
  "Berkane",
  "Berrechid",
  "Biougra",
  "Bouarfa",
  "Boujdour",
  "Boujniba",
  "Boulemane",
  "Bouskoura",
  "Bouznika",
  "Casablanca",
  "Chefchaouen",
  "Chichaoua",
  "Dakhla",
  "Demnate",
  "Drarga",
  "El Aïoun Sidi Mellouk",
  "El Hajeb",
  "El Jadida",
  "El Kelaâ des Sraghna",
  "Errachidia",
  "Essaouira",
  "Fès",
  "Figuig",
  "Fkih Ben Salah",
  "Fnideq",
  "Fquih Ben Salah",
  "Goulmima",
  "Guelmim",
  "Guercif",
  "Ifrane",
  "Imzouren",
  "Inezgane",
  "Jerada",
  "Kalaat MGouna",
  "Kénitra",
  "Khémisset",
  "Khénifra",
  "Khouribga",
  "Ksar El Kébir",
  "Laâyoune",
  "Larache",
  "Lqliâa",
  "MDiq",
  "Marrakech",
  "Martil",
  "Mechra Bel Ksiri",
  "Mediouna",
  "Meknès",
  "Midelt",
  "Missour",
  "Mohammedia",
  "Moulay Bousselham",
  "Nador",
  "Ouarzazate",
  "Ouazzane",
  "Oued Zem",
  "Oujda",
  "Oulad Teima",
  "Rabat",
  "Rissani",
  "Safi",
  "Salé",
  "Sefrou",
  "Settat",
  "Sidi Bennour",
  "Sidi Ifni",
  "Sidi Kacem",
  "Sidi Slimane",
  "Skhirat",
  "Smara",
  "Souk El Arbaa",
  "Tafraout",
  "Tahla",
  "Taliouine",
  "Tan-Tan",
  "Tanger",
  "Taourirt",
  "Taroudant",
  "Tata",
  "Taza",
  "Témara",
  "Tétouan",
  "Tiflet",
  "Tinghir",
  "Tiznit",
  "Youssoufia",
  "Zagora",
  "Zaïo",
  "Zeghanghane",
] as const;

export type DemoCity = (typeof ALL_CITIES)[number] | typeof CITY_OTHER;

export function normalizeCitySearch(value: string): string {
  return (value || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

export function filterCities(query: string): DemoCity[] {
  const cityQ = normalizeCitySearch(query);
  const matches = ALL_CITIES.filter((city) => normalizeCitySearch(city).includes(cityQ));
  return [...matches, CITY_OTHER];
}

export function isValidDemoCity(city: string): city is DemoCity {
  return (ALL_CITIES as readonly string[]).includes(city) || city === CITY_OTHER;
}

export function isOnsiteCity(city: string): boolean {
  return (ONSITE_CITIES as readonly string[]).includes(city);
}

export function isCityOther(city: string): boolean {
  return city === CITY_OTHER;
}

/** Recap / form display: keeps list value Autre plus the free-text detail when provided. */
export function formatCityRecap(city: string, cityDetail?: string): string {
  if (!isCityOther(city)) return city;
  const detail = cityDetail?.trim();
  return detail ? `${CITY_OTHER} (${detail})` : CITY_OTHER;
}
